import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';
import { ShiftColorOptions, StaffLayoutStyle } from '@wilson/interfaces';
import { ShiftTimelinePreferredSettingsState } from '@wilson/preferred-settings/state';
import { first, Observable, shareReplay, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreferredSettingsStateFacadeService {
  private store = inject(Store);

  public readonly shiftColorOptions$: Observable<ShiftColorOptions> = this.store
    .select(AuthState.userId)
    .pipe(
      first((userId) => !!userId),
      switchMap((userId) =>
        this.store.select(
          ShiftTimelinePreferredSettingsState.shiftColorOptions(
            userId as string,
          ),
        ),
      ),
      shareReplay(1),
    );

  public readonly staffLayoutStyle$: Observable<StaffLayoutStyle> = this.store
    .select(AuthState.userId)
    .pipe(
      first((userId) => !!userId),
      switchMap((userId) =>
        this.store.select(
          ShiftTimelinePreferredSettingsState.getStaffLayoutStyle(
            userId as string,
          ),
        ),
      ),
      shareReplay(1),
    );
}
